module.exports = __webpack_public_path__ + "assets/img/block-right-fce4cb2c.png";